
/**
 * Attempts to determine an event's source parent by matching it with a target selector,
 * then calls a listener function with the source element referenced in event.delegateTarget.
 *
 * Usage example:
 *
 * <ul>
 *   <li>1</li>
 *   <li>2</li>
 *   <li>3</li>
 *   <li>4</li>
 * </ul>
 *
 * document.querySelector('ul').addEventListener('click', delegateListener('li', handleListItemClick));
 *
 * @param {string} target - CSS selector that should match the element in question
 * @param {function} listener - The event listener to call
 *
 * @returns {function} - A closure scoped function that can be used as an event listener
 */
const delegateListener = (target, listener) => {
  return (event) => {
    let candidate = event.target;
    while(!candidate.matches(target)) {
      candidate = candidate.parentNode;
      if(candidate === document.documentElement) return false;
    }
    event.delegateTarget = candidate;
    listener(event);
  }
}

export default delegateListener;
